import { connect } from 'react-redux';

// == Import : local
import { DrawGameKafka } from '../components/drawGameKafka';
// Action Creators
import { changeDrawStatus,switchDrawOff } from '../store/reducer/drawGameReducer';
import { baseUrlToUse,kafkaUrlToUse,websocketUrlToUse } from '../store/reducer/appReducer';
/* === State (données) ===
 * - mapStateToProps retroune un objet de props pour le composant de présentation
 * - mapStateToProps met à dispo 2 params
 *  - state : le state du store (getState)
 *  - ownProps : les props passées au container
 * Pas de data à transmettre ? const mapStateToProps = null;
 */
const mapStateToProps = (state) => ({ 
  drawStatus: state.drawGameReducer.drawStatus,
  baseUrlToUse:baseUrlToUse,
  kafkaUrlToUse:kafkaUrlToUse,
  websocketUrlToUse:websocketUrlToUse
});

/* === Actions ===
 * - mapDispatchToProps retroune un objet de props pour le composant de présentation
 * - mapDispatchToProps met à dispo 2 params
 *  - dispatch : la fonction du store pour dispatcher une action
 *  - ownProps : les props passées au container
 * Pas de disptach à transmettre ? const mapDispatchToProps = {};
 */
const mapDispatchToProps = (dispatch) => ({
  switchDrawStatus: () => {
    dispatch(changeDrawStatus())
  },
  switchDrawOff : ( )=>{
      dispatch(switchDrawOff())
  }
});

// Container
const DrawGameKafkaContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DrawGameKafka);

// == Export
export default DrawGameKafkaContainer;

/* = export à la volée
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Example);
*/